import * as React from "react";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// Single pill button standing in for a country <Select> — click opens a scrollable menu.
export default function CountryFilterButton({ value, onChange, options, disabled }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  return (
    <>
      <Button
        variant="outlined"
        disabled={disabled}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        endIcon={<ArrowDropDownIcon />}
        sx={{
          textTransform: "none",
          borderRadius: 1.5,
          borderColor: "#e0e0e0",
          color: "#333",
          fontWeight: value ? 600 : 400,
          backgroundColor: value ? "#EBEBEB" : "#FFFFFF",
          px: 1.25,
          maxWidth: 160,
          "&:hover": { backgroundColor: value ? "#EBEBEB" : "#f5f5f5", borderColor: "#e0e0e0" },
        }}
      >
        <Box component="span" sx={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          Country: {value || "All"}
        </Box>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        slotProps={{ paper: { sx: { maxHeight: 320 } } }}
      >
        <MenuItem
          selected={value === ""}
          onClick={() => {
            onChange("");
            setAnchorEl(null);
          }}
        >
          All
        </MenuItem>
        {options.map((c) => (
          <MenuItem
            key={c}
            selected={c === value}
            onClick={() => {
              onChange(c);
              setAnchorEl(null);
            }}
          >
            {c}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
